import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import fr from './locales/fr.json';
import en from './locales/en.json';

/**
 * i18n Configuration for Budgira
 * 
 * Supports French (fr) and English (en) languages.
 * Uses browser language detection on first visit.
 * 
 * @validates Requirements 13.1, 13.2 - Multi-language support (FR/EN)
 */

const resources = {
  fr: { translation: fr },
  en: { translation: en },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    
    detection: {
      // Order of language detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache user language preference in localStorage
      caches: ['localStorage'],
      lookupLocalStorage: 'budgira_language',
    },

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    react: {
      useSuspense: false, // Disable suspense for non-blocking loading
    },
  });

export default i18n;

/**
 * Get the current language
 */
export const getCurrentLanguage = (): 'fr' | 'en' => {
  return i18n.language as 'fr' | 'en';
};

/**
 * Change the current language
 */
export const changeLanguage = async (lang: 'fr' | 'en'): Promise<void> => {
  await i18n.changeLanguage(lang);
};

/**
 * Get available languages
 */
export const getAvailableLanguages = (): Array<{ code: 'fr' | 'en'; name: string }> => {
  return [
    { code: 'fr', name: 'Français' },
    { code: 'en', name: 'English' },
  ];
};
